import React from 'react';
import ReactDOM from 'react-dom/client';
import { SkimPanel } from './SkimPanel';
import './skim.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SkimPanel />
  </React.StrictMode>,
);

// Request durable storage. On a normal web origin (unlike chrome-extension://)
// IndexedDB + the WebLLM model cache can be evicted under disk pressure —
// which would silently destroy the hash-chained audit log and force a ~5 GB
// model re-download. Asking for persistence makes the store best-effort
// durable; it is idempotent and granted silently once the app is installed or
// engaged with. No user data leaves the device either way.
if ('storage' in navigator && typeof navigator.storage.persist === 'function') {
  void navigator.storage.persisted().then((already) => {
    if (!already) void navigator.storage.persist().catch(() => undefined);
  });
}

// Service worker: offline app shell + runtime network-allowlist guard.
// Registered in production only — in dev it would cache stale Vite modules.
// In dev we proactively unregister any SW left over from a prior prod build.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      void navigator.serviceWorker
        .register(`${import.meta.env.BASE_URL}sw.js`, { scope: import.meta.env.BASE_URL })
        .catch(() => undefined);
    });
  } else {
    void navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => void r.unregister()))
      .catch(() => undefined);
  }
}
